export default __webpack_public_path__ + "static/media/info.44423484.svg";